import cfg, {UPDATE_ERROR, UPDATE_SIGNIN, handleResponse, UPDATE_LANGUAGE, handlePrepareData} from "../constants";

const DEFAULT_HEADERS = {
  'Accept': 'application/json',
  'Content-Type': 'application/json'
};

// authAction - auth user with login/password
export const authAction = (body) => (dispatch, getState) => {
  return fetch(cfg.base_url + '/auth/authenticate', {
    method: "POST",
    headers: DEFAULT_HEADERS,
    body: JSON.stringify(body)
  }).then(handleResponse).then((data) => {
    if (data.status === 'ok' && data.user && data.user.token) {
      data.user.modules = data.user.modules ? data.user.modules.split(',').reduce((acc, m) => ({...acc, [m]: true}), {}) : {};
      storeUser(data.user);
      dispatch({type: UPDATE_SIGNIN, profile: data.user, clear: true});
      if (data.user.language) {
        storeLanguage(data.user.language);
        dispatch({type: UPDATE_LANGUAGE, lang: data.user.language});
      }
      return data.user;
    }
    if (data.errors && data.errors.length > 0) {
      throw new Error(data.errors[0]);
    }
    throw new Error('error_other');
  });
};

// registerAction - user sign up
export const registerAction = (body) => (dispatch, getState) => {
  return fetch(cfg.base_url + '/auth/register', {
    method: "POST",
    headers: DEFAULT_HEADERS,
    body: JSON.stringify(body)
  }).then(handleResponse).then((data) => {
    if (data.status === 'ok') {
      data.user.modules = data.user.modules ? data.user.modules.split(',').reduce((acc, m) => ({...acc, [m]: true}), {}) : {};
      storeUser(data.user);
      dispatch({type: UPDATE_SIGNIN, profile: data.user, clear: true});
      if (data.user.language) {
        storeLanguage(data.user.language);
        dispatch({type: UPDATE_LANGUAGE, lang: data.user.language});
      }
      return data.user;
    }
    if (data.errors && data.errors.length > 0) {
      throw new Error(data.errors[0]);
    }
    throw new Error('error_other');
  });
};

// restoreAction
export const restoreAction = (body) => (dispatch, getState) => {
  return fetch(cfg.base_url + '/auth/restore', {
    method: "POST",
    headers: DEFAULT_HEADERS,
    body: JSON.stringify(body)
  }).then(handleResponse).then(handlePrepareData);
};

// authMiddleware - prepare headers for POST requests
export function authMiddleware(dispatch, getState, isPublic = false, onlyToken = false) {
  //const profile = getState().user.profile;
  const profile = getUser();
  if (!profile.token) {
    dispatch({type: UPDATE_SIGNIN, profile: profile});
    if (!isPublic) {
      window.location = '/login';
    }
    return {};
  }
  const duration = (profile.expires - Math.floor(Date.now() / 1000)) / 60;

  const headers = {
    "Accept": "application/json",
    'Content-Type': 'application/json',
    'Authorization': 'Bearer ' + profile.token
  };

  // if duration less 10 minutes, send refresh
  if ( duration <= 10 ) {
    fetch(cfg.base_url + '/auth/refresh-token', {method: "POST", headers: headers}).then(response => response.json())
      .then((data) => {
        if (data.status === 'ok' && data.user && data.user.token) {
          profile.token = data.user.token;
          profile.expires = data.user.expires;
          storeUser(data.user);
          dispatch({type: UPDATE_SIGNIN, profile: data.user});
        }
        if (data.errors && data.errors.length > 0) {
          throw new Error(data.errors[0]);
        }
        throw new Error('error_other');
      }).catch(error => {
      dispatch({type: UPDATE_ERROR, errors: ['error_other']});
    });
  }

  if (onlyToken) {
    return profile.token;
  }
  return headers
}

// authToken - get token for GET requests
export function authToken(dispatch, isPublic) {
  const profile = getUser();
  if (!profile.token) {
    dispatch({type: UPDATE_SIGNIN, profile: profile});
    if (!isPublic) {
      window.location = '/login';
    }
    return '';
  }
}

export function storeUser(user = {}) {
  localStorage.setItem('dc_current_user', JSON.stringify(user));
}

export function removeUser() {
  localStorage.removeItem('dc_current_user');
}

export function getUser() {
  let user =  localStorage.getItem('dc_current_user');
  user = user ? JSON.parse(user) : '';
  const seconds = new Date().getTime() / 1000;
  if (!user || user.expires < seconds) {
    return {};
  }
  return user;
}

export function getLanguage() {
  const lang = localStorage.getItem('dc_current_language');
  if (lang) {
    return lang;
  }
  let def = getDeviceLanguage();
  switch (def) {
    case 'uk':
    case 'ru':
      return 'ru';
    default:
      return 'en';
  }
}

export function storeLanguage(lang) {
  localStorage.setItem('dc_current_language', lang);
}

function getDeviceLanguage() {
  let defaultLang = 'en';
  if (typeof navigator === 'undefined') {
    return defaultLang;
  }
  let nav = navigator; // eslint-disable-line no-undef
  if (nav) {
    if (nav.language) {
      return nav.language.split('-')[0].toLowerCase();
    }
    if (!!nav.languages && !!nav.languages[0]) {
      return nav.languages[0].split('-')[0].toLowerCase();
    }
    if (nav.userLanguage) {
      return nav.userLanguage.split('-')[0].toLowerCase();
    }
    if (nav.browserLanguage) {
      return nav.browserLanguage.split('-')[0].toLowerCase();
    }
  }
  return defaultLang;
}
